import * as React from "react";
import { DayPicker } from "react-day-picker";
import "react-day-picker/dist/style.css";

import { cn } from "../../lib/utils";
import { buttonVariants } from "./button";

function Calendar({ className, showOutsideDays = true, toYear, ...props }) {
  const currentYear = new Date().getFullYear();
  return (
    <DayPicker
      showOutsideDays={showOutsideDays}
      className={cn(props.mode === "range" ? "" : "p-3", className)}
      classNames={{
        months:
          props.mode === "range"
            ? "rdp-months justify-center relative mt-1 !gap-y-0"
            : "relative",
        month: props.mode === "range" ? "space-y-1 md:mt-4" : "space-y-4",
        month_caption:
          props.mode === "range"
            ? "flex justify-center items-center px-2 w-full pb-3"
            : "flex justify-center items-center px-2 w-full",
        nav:
          props.mode === "range"
            ? "w-full flex items-center justify-between -mb-10 h-6 md:mt-4"
            : "w-full flex items-center justify-between -mb-6 h-6",
        button_previous: cn(
          buttonVariants({ variant: "outline" }),
          "h-6 w-6 bg-transparent p-0 opacity-50 hover:opacity-100 absolute left-1 hover:fill-accent-foreground"
        ),
        chevron:
          "fill-accent-foreground dark:fill-white hover:fill-accent-foreground",
        button_next: cn(
          buttonVariants({ variant: "outline" }),
          "h-6 w-6 bg-transparent p-0 opacity-50 hover:opacity-100 absolute right-1 hover:fill-accent-foreground"
        ),
        table: "w-full border-collapse space-y-1",
        head: "flex",
        headCell:
          "text-muted-foreground rounded-md w-8 font-normal text-[0.8rem]",
        row: "flex w-full mt-2",
        day: cn(
          "!h-8 !w-8 p-0 rounded-md text-center text-sm font-normal aria-selected:opacity-100 hover:bg-accent hover:text-accent-foreground",
          "focus-within:relative focus-within:z-20",
          props.mode === "range"
            ? "rounded-none"
            : "[&:has([aria-selected])]:rounded-md"
        ),
        day_button: cn(
          "!h-8 !w-8 p-0 rounded-md text-center text-sm font-normal aria-selected:opacity-100",
          "focus-within:relative focus-within:z-20",
          props.mode === "range"
            ? "rounded-none"
            : "[&:has([aria-selected])]:rounded-md"
        ),
        range_start: "rounded-l-md bg-primary text-primary-foreground",
        range_end: "rounded-r-md bg-primary text-primary-foreground",
        range_middle:
          "bg-accent text-accent-foreground aria-selected:bg-accent aria-selected:text-accent-foreground",
        selected:
          "bg-webPrimary text-white hover:bg-webPrimary hover:text-white focus:bg-webPrimary focus:text-white",
        today: "bg-accent text-webPrimary",
        outside: "text-muted-foreground opacity-50",
        disabled: "text-muted-foreground opacity-50",
        hidden: "invisible",
        months_dropdown: "!px-3",
        years_dropdown: "!px-3",
        weekday: "bg-webPrimary text-white",
        week: "border-y-2 border-background",
      }}
      captionLayout={props.mode === "range" ? "label" : "dropdown"}
      // toYear={toYear ? new Date().getFullYear() + 10 : ""}
      startMonth={new Date(currentYear - 50, 0)} // 50 years back
      endMonth={new Date(currentYear + 50, 11)} // 50 years ahead
      {...props}
    />
  );
}

Calendar.displayName = "Calendar";

export { Calendar };
